import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useFormik } from "formik";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { SurveyFormikAssign } from "./Constants";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useSelector } from "react-redux";
import { assignedQuestionnaireToOrganization } from "../../api/Questionnaire";
import { getOrganization } from "../../api/Organization";
import { useSurveyQueryData } from "../../../hooks/ReactQueryHooks/useSurveyQueryData";
import { debounce } from 'lodash';

const AssignSurvey = ({ modalData, handleHide, refreshTable }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations);
  const [questionnaireWroom, setQuestionnaireWroom] = useState([{ name: "", value: "" }]);
  const userType = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const admin = userType?.includes('Super-Admin');
  const [orgID, setOrgID] = useState(admin ? "All" : adminOrgs?.[0]?.id);
  const debouncedGetOrganization = debounce((data, orgId) => {
    getOrganization(orgId)
      .then((res) => {
        const assignedQuestionnaire = res?.data?.assignedQuestionnaire || {};
        if (assignedQuestionnaire["survey-waitingroom"]) {
          const foundWaitingItem = assignedQuestionnaire["survey-waitingroom"]
            ? data?.find((item) => item?.id === assignedQuestionnaire["survey-waitingroom"])
            : '';
          if (foundWaitingItem) {
            formik.setFieldValue("questionnaireWroomField", foundWaitingItem?.id || "");
          }
        }
      })
      .catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res?.message));
  }, 500);
  const onSuccess = (data) => {
    debouncedGetOrganization(data, adminOrgs?.[0]?.id);
  };
  const debouncedSuccess = debounce(onSuccess, 500);
  const { data: programList } = useSurveyQueryData({ orgID, onSuccess: debouncedSuccess });
  const formik = useFormik(
    {
      ...SurveyFormikAssign,
      onSubmit: (values) => {
        values.purpose = values.purpose?.trim(); 
        let payload = {};
        payload = {
          "assignedQuestionnaire": {
            "survey-waitingroom": values.questionnaireWroomField,
          }
        }
        setBtnLoading(true);
        assignedQuestionnaireToOrganization(adminOrgs?.[0]?.id, payload)
          .then(() => {
            success("Survey Assigned Successfully.");
            handleHide();
            refreshTable();

          })
          .catch((res) => failed(res?.response?.data?.message || res?.response?.data?.error || res.message))
          .finally(() => setBtnLoading(false));
      },
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (programList) {
          const foundObjectSwating = programList.some(item => item.purpose === "survey-waitingroom");
          if (foundObjectSwating === true) {
            const filteredQuestionnaireWroom = programList
              .filter((item) => (item?.purpose === 'survey-waitingroom' && item?.status === 'active'))
              .map((dataItem) => ({ name: dataItem?.title, value: dataItem?.id }));
            if (filteredQuestionnaireWroom.length > 0) {
              setQuestionnaireWroom(filteredQuestionnaireWroom);
            }
          }
        }
      } catch (error) {
        // console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [programList]);


  const handlePurposeChange = (fieldName, e) => {
    formik.setFieldValue(fieldName, e.target.value);
  }
  return (
    <Modal
      show={modalData}
      onHide={handleHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
      backdropClassName
      backdrop={"static"}
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter">
          Assign Survey Questionnaire

        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row style={{ width: '100%', marginBottom: '10px', padding: '5px 10px' }}>

          <Col>
            {/* <h6>Questionnaire</h6> */}
            <form
              className="common-form border-fields"
              onSubmit={formik.handleSubmit}
            >



              <SelectFiled
                keyField={"questionnaireWroomField"}
                formik={formik}
                placeholder={"Select"}
                options={questionnaireWroom}
                onChange={(e) => handlePurposeChange('questionnaireWroomField', e)}
              />


              <div
                className="btn-wrap"
                style={{ display: "flex", marginTop: "2rem" }}
              >
                <Button variant="secondary" title="Cancel" onClick={handleHide}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  isLoading={btnLoading}
                // disabled={isLoading || isFetching}
                >
                  Save
                </Button>
              </div>
            </form>
          </Col>


        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default AssignSurvey;
